<template>
  <asc-dialog
    :show-dialog="showDialog"
    :text="title"
    :on-close="handleClose"
    :width="1000"
  >
    <template v-if="showDialog && !isEventReport">
      <asc-report-summary :report-data="reportData"></asc-report-summary>
    </template>
    <template v-if="showDialog && isEventReport">
      <asc-event-report-summary
        :report-data="reportData"
      ></asc-event-report-summary>
    </template>
  </asc-dialog>
</template>

<script>
import { AscDialogMixin } from '@/components/mixins'
import AscDialog from '@/components/atoms/AscDialog'
import AscReportSummary from '@/components/molecules/AscReportSummary'
import AscEventReportSummary from '@/components/molecules/AscEventReportSummary'

export default {
  name: 'AscReportSummaryDialog',

  components: {
    AscDialog,
    AscReportSummary,
    AscEventReportSummary,
  },

  mixins: [AscDialogMixin],

  props: {
    title: {
      type: String,
      default: 'Report Summary',
    },
    reportData: {
      type: Array,
      default: () => [],
    },
    isEventReport: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
